import i18n from 'i18n';
export function selectOptionsAddI18n(
  selectOptions: SelectOptions,
  prefix?: string[]
) {
  if (!selectOptions) {
    return {};
  }
  const { label, value, options } = selectOptions;
  let labelI18n = i18n.t(label);
  if (prefix && prefix.length > 0) {
    labelI18n = i18n.t(prefix.map((p) => `${p}${label}`));
  }
  return {
    label: labelI18n,
    value,
    ...(options && {
      options: options.map((option) => selectOptionsAddI18n(option, prefix))
    })
  };
}

export function generateI18nOfSelectOptions(
  selectOptions: SelectOptions,
  prefix: string,
  formatter?: (value: any) => any
) {
  if (!selectOptions) {
    return;
  }
  const { label, value, options } = selectOptions;
  const finalValue = formatter ? formatter(value) : value;
  const key = `${prefix}.${finalValue}`;
  i18n.addResource('en', 'translation', key, label);
  i18n.addResource('zh-TW', 'translation', key, label);
  i18n.addResource('ja', 'translation', key, label);
  options &&
    options.map((option) =>
      generateI18nOfSelectOptions(option, prefix, formatter)
    );
}

export function getI18nString(i18nKey: string, defaultValue: string) {
  if (i18n.exists(i18nKey)) {
    return i18n.t(i18nKey);
  }
  return defaultValue;
}

/**
 * ECOPD-5566：停用渠道名稱後面接的「(停用)」。
 *
 * 三語的值凍結在 locale 裡：en `(Archived)` / zh-TW `(停用)` / ja `(停止中)`，
 * **一律半形括號、沒有前導空白**。
 */
export const SALES_CHANNEL_ARCHIVED_SUFFIX_KEY =
  'channelGroup.labels.archivedSuffix';

/**
 * 把停用後綴接到渠道名稱後面：**基底名 + 一個半形空格 + 後綴**，三語同一條規則。
 *
 *   Fridge (Archived) / 冰櫃 (停用) / 冷蔵庫 (停止中)
 *
 * ⚠️ 空格屬於**串接**、不屬於後綴值 —— 所以英文的 locale 值沒有前導空白，
 * 別看到 `(Archived)` 就以為漏了空格而去改 locale。
 * 這是全站唯一施加後綴的地方，凡是要加後綴一律走這裡，才不會出現寬度不一的版本。
 */
export function withSalesChannelArchivedSuffix(
  name: string,
  lng?: string
): string {
  const suffix = lng
    ? i18n.t(SALES_CHANNEL_ARCHIVED_SUFFIX_KEY, { lng })
    : i18n.t(SALES_CHANNEL_ARCHIVED_SUFFIX_KEY);
  return `${name} ${suffix}`;
}

/**
 * 銷售渠道的顯示名稱（停用渠道**帶後綴**）。
 *
 * 後綴由前端在 `RestfulChannelGroupWebService.wrapChannelGroup` 灌
 * `salesChannels.<id>` 這個 runtime resource 時施加**一次**，所以讀取端只要照念。
 *
 * ⚠️ 不是每個地方都該用它 —— 報表下載檔名要的是**不帶後綴**的原名，
 * 走 `ChannelGroupSetting.findById(id)?.config.name`。
 */
export function getSalesChannelName(
  channelId: number | string,
  defaultValue = ''
): string {
  return getI18nString(`salesChannels.${channelId}`, defaultValue);
}
